import Box from "../primitives/box";

/**
 * @deprecated Use noted components package instead.
 */
export const TableHead = Box.withComponent("thead");

TableHead.displayName = "TableHead";

export default TableHead;
